module.exports = __webpack_public_path__ + "img/login_page_img.bdcd62ba.png";